import * as $ from 'jquery';

export function init(root) {
    const config = root.data('shipping-progress-config');
    let url = config.stateUrl;
    if (config.currentState !== config.finalState) {
        setInterval(() => {
            $.get({
                url: url
            }).done((response, textStatus, xhr) => {
                if (!response || xhr.status === 304) {
                    return;
                }
                if (response.html && response.newState) {
                    window.location.reload();
                }
            }).fail(response => {
                console.log(response);
            });
        }, config.refreshInterval);
    }
}
